import initializeForm from './initializeForm';
import toggleModal from './openModal';
import resetForm from './resetForm';

export default (values) => (dispatch) => {
    dispatch(resetForm());
    const newValues = {
        file: values.file,
        id: values.id,
        name: values.name,
        system: values?.system?.id,
    };
    dispatch(initializeForm(newValues));
    dispatch(toggleModal(true));
};
